/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Xmlid7207IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Xmlid7207Icon(props: Xmlid7207IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 40 40"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M19.51 39.02c10.775 0 19.51-8.735 19.51-19.51S30.285 0 19.51 0 0 8.735 0 19.51s8.735 19.51 19.51 19.51"
        }
      ></path>
    </svg>
  );
}

export default Xmlid7207Icon;
/* prettier-ignore-end */
